import React from 'react';
import { Card } from 'tdesign-react';
import JsonView from 'react18-json-view';
import { useOcrStore } from '../../../../store';
import { copyToClipboard } from '../utils';

/**
 * 复制图标组件
 */
const CopyIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8667 3H11.6667H8.13332H6.0531C6.07427 2.89777 6.10389 2.80931 6.14531 2.72801C6.27315 2.47713 6.47712 2.27316 6.728 2.14532C7.01322 2 7.38659 2 8.13332 2H11.8667C12.6134 2 12.9868 2 13.272 2.14532C13.5229 2.27316 13.7268 2.47713 13.8547 2.72801C14 3.01323 14 3.3866 14 4.13333V9.2C14 9.94674 14 10.3201 13.8547 10.6053C13.7268 10.8562 13.5229 11.0602 13.272 11.188C13.1907 11.2294 13.1022 11.259 13 11.2802V4.33333L13 4.32807V4.13333C13 3.74346 12.9992 3.5112 12.9851 3.33903C12.9766 3.23396 12.9652 3.18979 12.9616 3.17795C12.9302 3.11843 12.8816 3.06979 12.822 3.03843C12.8102 3.03476 12.766 3.02343 12.661 3.01484C12.4888 3.00078 12.2565 3 11.8667 3ZM12.8255 3.03964L12.8235 3.03889L12.8249 3.03937C12.8253 3.03954 12.8255 3.03963 12.8255 3.03964ZM12.9605 3.17494C12.9604 3.17462 12.9604 3.17448 12.9604 3.1745L12.9611 3.17652C12.9609 3.17579 12.9607 3.17527 12.9605 3.17494ZM4.13333 5C3.74346 5 3.5112 5.00078 3.33903 5.01484C3.23396 5.02343 3.18979 5.03476 3.17795 5.03843C3.11843 5.06979 3.06979 5.11843 3.03843 5.17795C3.03476 5.18979 3.02343 5.23396 3.01484 5.33903C3.00078 5.5112 3 5.74346 3 6.13333V11.8667C3 12.2565 3.00078 12.4888 3.01484 12.661C3.02343 12.766 3.03476 12.8102 3.03843 12.8221C3.06979 12.8816 3.11843 12.9302 3.17795 12.9616C3.18978 12.9652 3.23395 12.9766 3.33903 12.9852C3.5112 12.9992 3.74346 13 4.13333 13H9.86667C10.2565 13 10.4888 12.9992 10.661 12.9852C10.766 12.9766 10.8102 12.9652 10.8221 12.9616C10.8816 12.9302 10.9302 12.8816 10.9616 12.8221C10.9652 12.8102 10.9766 12.766 10.9852 12.661C10.9992 12.4888 11 12.2565 11 11.8667V6.13333C11 5.74346 10.9992 5.5112 10.9852 5.33903C10.9766 5.23396 10.9652 5.18979 10.9616 5.17795C10.9302 5.11843 10.8816 5.06979 10.822 5.03843C10.8102 5.03476 10.766 5.02343 10.661 5.01484C10.4888 5.00078 10.2565 5 9.86667 5H4.13333ZM10.8255 5.03964L10.8235 5.03889C10.8249 5.03936 10.8255 5.03962 10.8255 5.03964ZM10.9604 5.1745C10.9604 5.17446 10.9606 5.1751 10.9611 5.17652L10.9604 5.1745ZM10.9604 12.8255L10.9611 12.8235C10.9606 12.8249 10.9604 12.8255 10.9604 12.8255ZM10.8255 12.9604C10.8255 12.9604 10.8249 12.9606 10.8235 12.9611L10.8255 12.9604ZM3.1745 12.9604L3.17652 12.9611C3.17509 12.9606 3.17446 12.9604 3.1745 12.9604ZM3.03964 12.8255C3.03962 12.8255 3.03936 12.8249 3.03889 12.8235L3.03964 12.8255ZM3.03964 5.1745L3.03889 5.17652C3.03936 5.1751 3.03962 5.17446 3.03964 5.1745ZM3.1745 5.03964C3.17446 5.03962 3.1751 5.03936 3.17652 5.03889L3.1745 5.03964ZM2 6.13333C2 5.3866 2 5.01323 2.14532 4.72801C2.27316 4.47713 2.47713 4.27316 2.72801 4.14532C3.01323 4 3.3866 4 4.13333 4H9.86667C10.6134 4 10.9868 4 11.272 4.14532C11.5229 4.27316 11.7268 4.47713 11.8547 4.72801C12 5.01323 12 5.3866 12 6.13333V11.8667C12 12.6134 12 12.9868 11.8547 13.272C11.7268 13.5229 11.5229 13.7268 11.272 13.8547C10.9868 14 10.6134 14 9.86667 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V6.13333Z" fill="#030A26" fillOpacity="0.65" />
  </svg>
);

/**
 * RecognizeAgent 结果渲染器
 * 根据 QueryType 渲染不同格式的识别结果
 */
const RecognizeAgentRenderer = ({ params, config, isLoading }) => {
  const request = useOcrStore(state => state.request);
  const queryType = request?.QueryType ?? 0;

  // 适配接口返回结构：Response 是数组，取第一个元素
  const responseArr = params[config.firstField];
  const responseItem = Array.isArray(responseArr) ? responseArr[0] : responseArr;

  if (!responseItem) return null;

  // 全文识别：从 TextDetections 展示纯文本
  if (queryType === 0) {
    const textDetections = responseItem.TextDetections || [];
    if (!textDetections.length) return null;
    return (
      <div className="recognize-agent-result__text">
        {textDetections.map((item, index) => (
          <p key={index} style={{ margin: '4px 0', lineHeight: '1.8' }}>
            {item.DetectedText}
          </p>
        ))}
      </div>
    );
  }

  // 智能判断 / 自动分类 / 总结提炼：展示 Answer
  if (queryType === 1 || queryType === 2 || queryType === 3) {
    const answer = responseItem.Answer;
    if (!answer) return null;
    return (
      <div className="recognize-agent-result__summary">
        <div className="recognize-agent-result__summary-item">
          <div className="recognize-agent-result__summary-answer">
            {answer}
          </div>
          {responseItem.QueryInfo && (
            <div className="recognize-agent-result__summary-desc">
              {responseItem.QueryInfo}
            </div>
          )}
        </div>
      </div>
    );
  }

  // 信息提取：卡片式 Key-Value 展示
  if (queryType === 4) {
    const extractFields = responseItem.ExtractFields || [];
    if (!extractFields.length) return null;

    // 实际响应结构（递归嵌套）：
    //   node = { KeyName, KeyType, KeyValue?, SubItems?, Groups? }
    //   SubItems[i] 是下一层的容器节点（其 Groups 才包含具体字段）
    //   Groups[i] 可能是叶子 Key-Value（带 KeyValue），也可能是嵌套容器（带 SubItems）
    //
    // 渲染一个节点：展示其 Groups 内的字段列表
    const renderNode = (node, nodeIdx, depth = 0) => {
      const containerClass = [
        'recognize-agent-extract-card__sub',
        depth >= 1 && 'recognize-agent-extract-card__sub-sub',
        depth >= 2 && 'recognize-agent-extract-card__sub-sub--deep',
      ].filter(Boolean).join(' ');

      const groups = node.Groups || [];

      return (
        <div key={`${depth}-${nodeIdx}`} className={containerClass}>
          {/* 非顶层显示节点名称；顶层节点（L1 的 SubItems[i]）通常没 KeyName，不显示。二级/三级不再显示 #序号 */}
          {depth > 0 && node.KeyName && (
            <div className="recognize-agent-extract-card__sub-title">
              <span className="recognize-agent-extract-card__sub-name">
                {node.KeyName}
              </span>
            </div>
          )}
          {groups.map((g, gIdx) => {
            // Groups[g] 含 SubItems 时：它作为下一级容器（递归）
            if (g.SubItems && g.SubItems.length) {
              // 只有一级列表（depth===0）显示 #序号；二级/三级子字段仅显示名称
              const showIndex = depth === 0;
              return (
                <div
                  key={gIdx}
                  className="recognize-agent-extract-card__sub-sub"
                >
                  <div className="recognize-agent-extract-card__sub-title">
                    {showIndex && (
                      <span className="recognize-agent-extract-card__sub-index">
                        #{gIdx + 1}
                      </span>
                    )}
                    <span className="recognize-agent-extract-card__sub-name">
                      {g.KeyName || `字段${gIdx + 1}`}
                    </span>
                  </div>
                  {g.SubItems.map((next, nextIdx) =>
                    renderNode(next, nextIdx, depth + 1),
                  )}
                </div>
              );
            }
            // 叶子项：直接展示 KeyName + KeyValue
            return (
              <div
                key={gIdx}
                className="recognize-agent-extract-card__sub-item"
              >
                <span className="recognize-agent-extract-card__sub-key">
                  {g.KeyName}：
                </span>
                <span>{g.KeyValue}</span>
              </div>
            );
          })}
        </div>
      );
    };

    const renderField = (field, index) => {
      // KeyType=1 列表字段，含子项
      if (field.KeyType === 1 && field.SubItems) {
        return (
          <div key={index} className="recognize-agent-extract-card">
            <div className="recognize-agent-extract-card__key">
              {field.KeyName}
            </div>
            {field.SubItems.map((sub, sIdx) =>
              renderNode(sub, sIdx, 0),
            )}
          </div>
        );
      }
      // KeyType=0 普通字段
      return (
        <div key={index} className="recognize-agent-extract-card">
          <div className="recognize-agent-extract-card__key">{field.KeyName}</div>
          <div className="recognize-agent-extract-card__value">{field.KeyValue}</div>
        </div>
      );
    };

    return (
      <div className="recognize-agent-result__extract">
        {extractFields.map(renderField)}
      </div>
    );
  }

  return null;
};

export default RecognizeAgentRenderer;
